import React, { useState } from "react";
import { DownloadOutlined } from "@ant-design/icons";

import DocumentsTree from "../../../Mandanten/Common/UserDetails/DocumentsTree";
import { useKontaxUserContext } from "../../../../contexts/KontaxUserContext";
import {
  DownloadAllButtonWrapper,
  DownloadAllButton,
} from "../../../Mandanten/ActivationView/UserDetails/styledComponents";
import api from "../../../../../api";

type BankStatementsTabProps = {
  setDocumentsCount?: (count: number) => void;
  year: number;
};

const BANK_STATEMENTS_CATEGORY_NAMES = ["BANK_STATEMENTS"];

const BankStatementsTab = (props: BankStatementsTabProps) => {
  const { user, editUser } = useKontaxUserContext();
  const [selectedDocumentIds, setSelectedDocumentIds] = useState<string[]>([]);
  const [allDocumentIds, setAllDocumentIds] = useState<string[]>([]);

  const onSelectDocumentHandler = (ids: string[], checked = true) => {
    if (!checked) {
      setSelectedDocumentIds((prev) => prev.filter((id) => !ids.includes(id)));
    } else {
      setSelectedDocumentIds((prev) => Array.from(new Set([...prev, ...ids])));
    }
  };

  if (!user) {
    return null;
  }

  const handleDownloadAll = async () => {
    const documentIds = selectedDocumentIds.length
      ? selectedDocumentIds
      : allDocumentIds;

    await api.kontax.downloadDocumentsArchive(user.email, documentIds);
  };

  return (
    <>
      {!!allDocumentIds.length && (
        <DownloadAllButtonWrapper>
          <DownloadAllButton
            icon={<DownloadOutlined />}
            onClick={handleDownloadAll}
          >
            {selectedDocumentIds.length ? "Download selected" : "Download all"}
          </DownloadAllButton>
        </DownloadAllButtonWrapper>
      )}
      <DocumentsTree
        user={user}
        editUser={(_, userData) => editUser(userData)}
        year={props.year}
        categoryNames={BANK_STATEMENTS_CATEGORY_NAMES}
        allowUpload
        setSelectedDocumentIds={onSelectDocumentHandler}
        setAllDocumentIds={setAllDocumentIds}
        setDocumentsCount={props.setDocumentsCount}
      />
    </>
  );
};

export default BankStatementsTab;
